import get from 'lodash/get';
import siteData from '../site_data_util';
import striptags from 'striptags';
import baseSeoUtil from '../base_seo_util';

export default function(state = {}, action = {}) {
  const isFranchise =
    get(action, 'franchisePage.type', null) === 'franchise-list';
  const site = get(state, 'config.site');
  const siteConf = siteData || {};
  const img = get(
    action,
    'franchisePage._embedded.wp:featuredmedia[0].source_url'
  );
  const wpTitle = get(action, 'franchisePage.title.rendered');
  const franchiseExcerpt = get(action, 'franchisePage.excerpt.rendered');
  const socialTitle = wpTitle ? striptags(wpTitle).trim() : ''; // displays for twitter and social platforms
  const seoTitle = get(action, 'franchisePage.title.rendered'); // displays on google and browser tab
  const description = franchiseExcerpt
    ? striptags(franchiseExcerpt).trim()
    : '';
  const url = get(action, 'franchisePage.acf.publicUrl');

  return baseSeoUtil({
    site,
    siteConf,
    title: seoTitle,
    url,
    description,
    image: img,
    articleSection: 'Amazon Unpacked',
    config: get(state, 'config'),
    facebookTitleOverride: isFranchise
      ? seoTitle
      : `${socialTitle} | Fast Company`,
    twitterTitleOverride: isFranchise
      ? seoTitle
      : `${socialTitle} | Fast Company`
  });
}
